export const GET_ALL_SMS_SEND_TEMPLATE = "GET_ALL_SMS_SEND_TEMPLATE"
export const CREATE_SMS_SEND_TEMPLATE = "CREATE_SMS_SEND_TEMPLATE"
export const UPDATE_SMS_SEND_TEMPLATE = "UPDATE_SMS_SEND_TEMPLATE"
export const DELETE_SMS_SEND_TEMPLATE = "DELETE_SMS_SEND_TEMPLATE"
export const SELECT_SMS_SEND_TEMPLATE = "SELECT_SMS_SEND_TEMPLATE"
